import React, { useEffect } from 'react';
import { StyledTableContainer } from './AttachChildStyles';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import { attachChildDucksModule, clearState, getAllRequests } from './AttachChildDucks';
import { useDispatch, useSelector } from 'react-redux';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { useTranslation } from 'react-i18next';
import './AttachChildTranslate';
import { requestsColumns } from './AttachChildColumns';
import useUserInfo from '../../components/_hooks/useUserInfo';
import Typography from '@material-ui/core/Typography';
import Button from '../../modules/Button/Button';
import { Box } from '@material-ui/core';
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import AttachChildDialog from './AttachChildDialog/AttachChildDialog';
import RequestInfoDialog from './RequestInfoDialog/RequestInfoDialog';

function AttachChildWithParent() {
  const data = useSelector(state => state[attachChildDucksModule].data);
  const pageNumber = useSelector(state => state[attachChildDucksModule].pageNumber);
  const loading = useSelector(state => state[attachChildDucksModule].loading);
  const attachChildModal = useSimpleModal();
  const requestInfoDialog = useSimpleModal();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useUserInfo();

  const loadData = filter => dispatch(getAllRequests(filter, user.iin));
  const { toPage, filter } = useTableFilter(loadData, '', {
    pageNumber: 1,
    pageSize: 10
  });

  useEffect(() => {
    dispatch(clearState());
  }, []);

  return (
    <div className="fullWidth mt3 mb3">
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: { xs: 'flex-start', md: 'space-between' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          mb: 2
        }}
      >
        <Typography
          children={t('attachChildTableTitle')}
          color="secondary"
          variant="h6"
        />
        <Button
          text={t('attachChildAttachButton')}
          loading={loading}
          variant="contained"
          color="secondary"
          disabled={loading}
          onClick={() => {
            attachChildModal.open({});
          }}
        />
      </Box>

      <StyledTableContainer>
        <div className="mt2">
          <StaticTablePaginated
            loading={loading}
            data={data}
            columns={requestsColumns({ t })}
            filterable={false}
            pageSize={10}
            onClickRow={({ row }) => {
              console.log(row);
              requestInfoDialog.open({ row });
            }}
            pagePagination={page => {
              if (page !== pageNumber) {
                toPage(page);
              }
            }}
          />
        </div>
      </StyledTableContainer>
      {attachChildModal.isOpen && (
        <AttachChildDialog
          open={attachChildModal.isOpen}
          onClose={attachChildModal.close}
          filter={filter}
          loading={loading}
          requesterIin={user.iin}
        />
      )}
      {requestInfoDialog.isOpen && (
        <RequestInfoDialog
          {...requestInfoDialog.data}
          open={requestInfoDialog.isOpen}
          onClose={requestInfoDialog.close}
        />
      )}
    </div>
  );
}

export default AttachChildWithParent;
